
import React from 'react';

function SessionAndStoreReset(dispatch, setAllDataOfContact, setGotData, navigate, path) {
    sessionStorage.setItem("userName", "");
    dispatch(setAllDataOfContact({}));
    setGotData(false);
    sessionStorage.setItem("fdasdfaRETRFDGFDH234%82ERXB23!45sgf", "DSFSDhew234%*dgffd126DR3$%sDFGF");
    sessionStorage.setItem("GdEGeSTESGEt2ERgsdf34GEEr", "sGsdkE34GseGHrSDX2F");
    navigate(path);
}

export default SessionAndStoreReset;